import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { EditableRichText } from 'shared'
import { STRING_EMPTY } from 'utils/constants'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './DescriptionSection.style'

const DescriptionSection = () => {
  const classes = useStyles()

  const { values, errors, setFieldValue, setValues } = useFormikContext()

  const { championship } = useSelector((state) => state.championships)

  const [activeEdit, setActiveEdit] = useState(false)

  const handleChangeRichText = (e) =>
    setValues((values) => ({
      ...values,
      description: e?.getHTML() || STRING_EMPTY,
      descriptionText: e?.getText().trim() || STRING_EMPTY
    }))

  return (
    <SectionBlock title='Descripción'>
      {championship.description || activeEdit ? (
        <EditableRichText
          entity={values}
          altMode
          setStatusSection={(state) => setFieldValue('sectionState', state)}
          field='description'
          repositoryId={values.id}
          className={classes.editor}
          activeModeEdit={true}
          error={errors.description || errors.descriptionText}
          onChange={handleChangeRichText}
        />
      ) : (
        <Typography
          color='primary'
          variant='h6'
          className={classes.addLink}
          onClick={() => setActiveEdit(true)}>
          + Añadir descripción
        </Typography>
      )}
    </SectionBlock>
  )
}

export default DescriptionSection
